.toast-container {
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 9999;
  pointer-events: none;
}

/* На мобилках выводим по центру снизу */
@media (max-width: 768px) {
  .toast-container {
    bottom: 80px; /* Чтобы не перекрывало bottom-nav */
    right: 50%;
    transform: translateX(50%);
    width: calc(100% - 32px);
    max-width: 400px;
    align-items: center;
  }
}

.toast {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: var(--surface);
  color: var(--text-primary);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  pointer-events: auto;
  cursor: pointer;
  border: 1px solid var(--surface-border);
  min-width: 250px;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  animation: toastSlideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes toastSlideIn {
  from { opacity: 0; transform: translateX(20px); }
  to { opacity: 1; transform: none; }
}

@media (max-width: 768px) {
  .toast {
    width: 100%;
  }
}

.toast-icon {
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toast-message {
  font-size: 0.95rem;
  font-weight: 500;
  line-height: 1.4;
}

.toast-success {
  border-left: 4px solid var(--success);
}

.toast-error {
  border-left: 4px solid var(--danger);
}

.toast-info {
  border-left: 4px solid var(--wb-primary);
}

.toast-warning {
  border-left: 4px solid var(--warning, #f59e0b);
}
